import create from "zustand";
import { devtools } from "zustand/middleware"

import { apiLogin, api_signUp, api_forgetPassword } from '../api/auth.api'

const loginStore = (set, get) => ({
	response: null,
	loading: false,
	s_forgetPassword:{
		response: null,
		loading: false
	},
	login: async (email, password) => {
		set({ loading: true})
		await apiLogin(email, password).then((r) => {
			set({ response: r.data })
			set({ loading: false})
			if(r.data.accessToken != null){
				localStorage.setItem('userDetails', JSON.stringify({ 'session_id': r.data.session_id, 'username': r.data.username, 'email': email, 'line_of_business': r.data.line_of_business}) )
				localStorage.setItem('auth_token', r.data.accessToken)
			}
		})
	},
	signUp: async (email, cnic) =>{
		set({ loading: true})
		await api_signUp(email, cnic).then((r) => {
			set({ loading: false})
			set({response: r.data})
		})
	},
	forgetPassword: async (email) => {
		set( { s_forgetPassword:{ response: null, loading: true } })
		await api_forgetPassword(email).then((r) => {
			set( { s_forgetPassword:{ response: r.data, loading: true } })
		}).catch((error) => {
			set( { s_forgetPassword:{ response: { message: 'Unable to Connect', response_code: '00' }, loading: false } })
		})
	}
	//signInWithEmailAndPassword(auth, email, password),
	///logout: () => ,//auth.signOut(),
	//register: (email: string, password: string) => ,
	//createUserWithEmailAndPassword(auth, email, password),
	//setLoading: (load: number) =>,
	//set((state: any) => ({ loading: load === -1 ? !state.loading : load })),
});

const userStore = create(loginStore);

export default userStore

/*

const createUserSlice = (set, get) => ({
	users: [],
	friends: [],
	fetchUsers: async () => {
	  const res = await fetch("https://jsonplaceholder.typicode.com/users");
  
	  set({ users: await res.json() });
	},
	addToFriends: (user) => {
	  set({
		friends: [...new Set([...get().friends, user])],
	  });
	},
	removeUserFromFriends: (userId) => {
	  set({
		friends: get().friends.filter((friend) => friend.id !== userId),
	  });
	},
  });
  
  export default createUserSlice;*/